export default function Map( props ) {

	//console.log( 'Map', props.cruise )

	let location = props.location_geo || "34.66531199852692,33.041561875675164"
	let zoom = props.zoom || 8
	if ( props.cruise && props.cruise.location_start_geo ) {
		location = props.cruise.location_start_geo
		zoom = props.cruise.location_start_zoom || 8
	}

	const apiKey = "AIzaSyAG3XxJdMP0ZZG5ogT_FHBlBrB-XtkeHIU"

	let src = "https://www.google.com/maps/embed/v1/place?key="
	src += apiKey
	src += "&q=" + location
	src += "&zoom=" + zoom

	return <>
		<iframe
		  frameBorder="0" 
		  style={{ 
		  	border:0, 
			width:'100%', 
			borderRadius:'var(--border-radius)',
			aspectRatio: '3 / 2',
		  }}
		  referrerPolicy="no-referrer-when-downgrade"
		  //src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAG3XxJdMP0ZZG5ogT_FHBlBrB-XtkeHIU&q="  + "&zoom=8"
		  src={ src }
		  allowFullScreen >
		</iframe>

	</>
}


